import React from 'react';
import { Alert } from '@/components/ui';
import { Vehicle } from '../../../types/Vehicle';

interface VehicleRepairHistorySectionProps {
  vehicle: Vehicle;
}

const VehicleRepairHistorySection: React.FC<VehicleRepairHistorySectionProps> = ({ vehicle }) => {
  return (
    <div>
      <h2>Repair History</h2>
      <Alert variant="info">
        <i className="bi bi-info-circle tw-mr-2"></i>
        This section is not yet developed.
      </Alert>
    </div>
  );
};

export default VehicleRepairHistorySection;
